import { IconProps } from "../../types/icon";

export default function ProfileIcon({className = ""}: IconProps) {
  return (
    <svg className={className} width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="clip-path">
          <rect width="18" height="18" transform="translate(0)" fill="currentColor"/>
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <g transform="translate(0 0)" clipPath="url(#clip-path)">
          <path d="M9.051,18.1a9.051,9.051,0,0,1-6.4-15.451,9.051,9.051,0,0,1,12.8,12.8,8.992,8.992,0,0,1-6.4,2.651m0-16.687a7.637,7.637,0,1,0,7.637,7.637A7.645,7.645,0,0,0,9.051,1.414M9.015,9.723A3.394,3.394,0,1,1,12.41,6.329,3.4,3.4,0,0,1,9.015,9.723m0-5.374A1.98,1.98,0,1,0,11,6.329a1.982,1.982,0,0,0-1.98-1.98M13.5,13.84a.707.707,0,0,0,.1-1,5.221,5.221,0,0,0-4.053-1.921H8.7a5.221,5.221,0,0,0-4.053,1.921.707.707,0,0,0,1.094.9,3.812,3.812,0,0,1,2.959-1.4h.839a3.812,3.812,0,0,1,2.959,1.4.707.707,0,0,0,1,.1Z" transform="translate(0 0)" fill="currentColor"/>
        </g>
      </g>
    </svg>
  )
}